// src/components/ui/CloseButton.js
import styled from 'styled-components';

const RedButton = styled.button`
  background-color: #FDECEA;     // vermelho claro pastel
  color: #D32F2F;                // vermelho forte
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #f9d6d3;   // tom mais escuro no hover
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

export default RedButton;
